import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { captureEmail } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export const Footer = () => {
  const { earn } = useStore();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await captureEmail({ email, source: "footer" });
      await earn("signup");
      setDone(true);
      toast.success("You're in — 10% off + 100 points added.");
    } catch { toast.error("Something went wrong. Try again."); }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] text-[#F4F2ED] grain">
      <div className="relative z-10 px-5 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-2 gap-14 pb-16 border-b border-white/10">
          <div>
            <h2 className="font-hero text-4xl sm:text-5xl leading-none">JOIN THE<br />LÉVINCHI FAM</h2>
            <p className="font-body text-white/60 mt-5 max-w-md">First access to drops, private restocks and 10% off your first order. No spam — only heat.</p>
          </div>
          <div className="flex items-end">
            {done ? (
              <p data-testid="footer-subscribed" className="font-display uppercase tracking-widest text-[#FFFFFF]">✓ You're on the list.</p>
            ) : (
              <form onSubmit={submit} className="w-full flex border-b border-white/30 focus-within:border-[#FFFFFF] transition-colors">
                <input
                  data-testid="footer-email-input"
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 bg-transparent py-4 outline-none font-body placeholder:text-white/40"
                />
                <button data-testid="footer-subscribe-btn" type="submit" className="overline px-2">Subscribe →</button>
              </form>
            )}
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-8 pt-10">
          <div className="font-hero text-3xl">LÉVINCHI LUXE</div>
          <div className="flex gap-14 flex-wrap">
            <div className="flex flex-col gap-3">
              <span className="overline text-white/40">Shop</span>
              <Link to="/collections/new" className="font-body text-sm text-white/80 hover:text-white">New Arrivals</Link>
              <Link to="/collections/tees" className="font-body text-sm text-white/80 hover:text-white">Tees</Link>
              <Link to="/collections/sets" className="font-body text-sm text-white/80 hover:text-white">Sets</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="overline text-white/40">Experience</span>
              <Link to="/rewards" className="font-body text-sm text-white/80 hover:text-white">Rewards</Link>
              <Link to="/wishlist" className="font-body text-sm text-white/80 hover:text-white">Wishlist</Link>
              <a href="https://www.instagram.com/levinchi.luxe" target="_blank" rel="noreferrer" className="font-body text-sm text-white/80 hover:text-white">Instagram</a>
            </div>
          </div>
        </div>
        <p className="font-mono text-[11px] text-white/30 mt-16">© {new Date().getFullYear()} LÉVINCHI LUXE · WEAR THE WORLD · Secure checkout by Shopify</p>
      </div>
    </footer>
  );
};
